function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1666667 5.20920461c.4602373 0 .8333333.37309604.8333333.83333333V19.979787l-3.1512879-.0005824.0001375-5.4406136h-2.3632932l-.0008443 5.4406136-10.24000003.0005824v-6.1632583c0-.4602373.37309604-.8333333.83333333-.8333333l6.2556667-.0009908.0008795-6.93966666c0-.46023729.3730961-.83333333.8333334-.83333333h6.9987417zM7.79065997 14.5409238H5.82124898v1.9434977h1.96941099v-1.9434977zm3.54217423-.0004626H9.36342319v1.9434977h1.96941101v-1.9434977zm7.0953324-4.2765862h-1.969411v1.9434977h1.969411V10.263875zm-3.5451371-.0018362h-1.969411v1.9434977h1.969411v-1.9434977zm-.0025226-3.49426198h-1.969411v1.94349769h1.969411V6.76777682zm3.5464997-.0024434h-1.9694109v1.94349769h1.9694109V6.76533342zM11.3574867.40161948l.052214.08355993c.2469372.39518215.126761.91572275-.2684212 1.16265996L2.25085876 7.20225741 0 4.94570341l.67374943-.42100537 1.47582557.63176321 2.9325267-1.83244606-3.03546325-2.3205959L3.18683094.29094795l4.36660524 1.48880606L8.93511152.91715278a.7155443.7155443 0 01.02349734-.0140649l1.23621784-.7698896c.3951822-.24693722.9157228-.12676095 1.16266.2684212z",
  fill: "currentColor",
  fillRule: "nonzero"
}));

var SvgFph = function SvgFph(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fph.b9bbe6b1.svg";
export { ForwardRef as ReactComponent };